import React from 'react'
import DefaultLayout from '../DefaultLayout'

const HowToUseWrapper = () => {
    return (
        <div className='py-20'>
            <DefaultLayout className='px-6 text-main-800'>
                <>

                    <h2 className='text-2xl font-semibold mb-8 text-center'>
                        使用例
                    </h2>

                    <div className=''>
                        <div className='flex flex-col sm:flex-row mb-10'>
                            <div className='py-8 w-full sm:w-1/2'>
                                <h3 className='font-semibold text-2xl mb-2'>1. 事前準備</h3>
                                <p className='font-semibold'>事前準備はリングと付属充電ケースを予め充電しておくだけ</p>
                            </div>
                            <div className="w-full sm:w-1/2">
                                <img className='w-full' src='https://hatchout.co.jp/s/wp-content/themes/understrap-child/custom-lp//charging.jpg' alt={"バインスタリングの充電画像"} width={500} height={500} />
                            </div>
                        </div>
                        <div className='flex flex-col sm:flex-row mb-10'>
                            <div className='py-8 w-full sm:w-1/2 sm:px-4'>
                                <h3 className='font-semibold text-2xl mb-2'>2. ご提供・計測</h3>
                                <p className='font-semibold'>それぞれの患者様に合わせてリングサイズを調整することが可能です。ご提供後はリングを指にはめるだけで計測が開始されます。</p>
                            </div>
                            <div className="w-full sm:w-1/2 sm:order-first">
                                <img className='w-full' src='https://hatchout.co.jp/s/wp-content/themes/understrap-child/custom-lp//confortable1.png' alt={"バインスタリング装着と計測イメージ画像"} width={500} height={500} />
                            </div>
                        </div>
                        <div className='flex flex-col sm:flex-row mb-10'>
                            <div className='py-8 w-full sm:w-1/2'>
                                <h3 className='font-semibold text-2xl mb-2'>3. 計測データ送信</h3>
                                <p className='font-semibold'>計測後は専用スマホアプリに沿ってデータを同期</p>
                            </div>
                            <div className="w-full sm:w-1/2">
                                <img className='w-full sm:h-80 object-contain' src='https://hatchout.co.jp/s/wp-content/themes/understrap-child/custom-lp//data-input.png' alt={"計測データ送信画像"} width={500} height={500} />
                            </div>
                        </div>
                        <div className='flex flex-col sm:flex-row mb-10'>
                            <div className='py-8 w-full sm:w-1/2 sm:px-4'>
                                <h3 className='font-semibold text-2xl mb-2'>4. データ確認</h3>
                                <p className='font-semibold'>専用ページにて計測データの確認・レポートダウンロードなどが可能です。データ同期後5分以内にデータが表示されます。</p>
                            </div>
                            <div className="sm:w-1/2 w-full sm:2 sm:order-first">
                                <img className='w-full' src='https://hatchout.co.jp/s/wp-content/themes/understrap-child/custom-lp//data-visualize.png' alt={"クラウドデータ確認画像"} width={500} height={500} />
                            </div>
                        </div>
                    </div>

                </>
            </DefaultLayout>
        </div>
    )
}

export default HowToUseWrapper